import React from 'react';
import { Task } from 'shared/types/task';
import { formatDateKey } from 'shared/utils/format-date-key';

import { UpcomingPeriod } from '../upcoming-period';
import * as Styled from './upcoming.style';
import { useUpcomingPeriods } from './use-upcoming-periods';

export type UpcomingProps = {
  task: Task;
};

export const Upcoming: React.FC<UpcomingProps> = ({ task }) => {
  const periods = useUpcomingPeriods(task);

  return (
    <Styled.List>
      {periods.map((period) => (
        <Styled.ListItem key={formatDateKey(period.date)}>
          <UpcomingPeriod task={task} period={period} />
        </Styled.ListItem>
      ))}
    </Styled.List>
  );
};
